import { render, staticRenderFns } from "./StoryWorldBuilding.vue?vue&type=template&id=eb15c4fe"
import script from "./StoryWorldBuilding.vue?vue&type=script&lang=js"
export * from "./StoryWorldBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports